import React from "react"
import AniLink from "gatsby-plugin-transition-link/AniLink"
import { globalHistory } from "@reach/router"

import nav_apps from "../assets/images/nav_apps.png"
import nav_apps_a from "../assets/images/nav_apps_active.png"
import nav_websites from "../assets/images/nav_websites.png"
import nav_websites_a from "../assets/images/nav_websites_active.png"
import nav_lectures from "../assets/images/nav_lectures.png"
import nav_lectures_a from "../assets/images/nav_lectures_active.png"
import nav_profile from "../assets/images/nav_profile.png"
import nav_profile_a from "../assets/images/nav_profile_active.png"
import nav_backstory from "../assets/images/nav_backstory.png"
import nav_backstory_a from "../assets/images/nav_backstory_active.png"
import nav_writeups from "../assets/images/nav_writeups.png"
import nav_writeups_a from "../assets/images/nav_writeups_active.png"

function SubnavList() {
  const path = globalHistory.location.pathname
  let transitionTime = 0.15

  if (path.startsWith("/projects")) {
    return (
      <div className="subnav">
        <AniLink
          fade
          to="/projects/apps"
          activeClassName="active"
          partiallyActive={true}
          duration={transitionTime}
        >
          <img
            draggable="false"
            className="on"
            src={nav_apps_a}
            alt="apps"
          />
          <img
            draggable="false"
            className="off"
            src={nav_apps}
            alt={"apps"}
          />
          <p>Apps</p>
        </AniLink>
        <AniLink
          fade
          to= "/projects/websites"
          activeClassName="active"
          partiallyActive={true}
          duration={transitionTime}
        >
          <img
            draggable="false"
            className="on"
            src={nav_websites_a}
            alt="websites"
          />
          <img
            draggable="false"
            className="off"
            src={nav_websites}
            alt="websites"
          />
          <p>Websites</p>
        </AniLink>
        <AniLink
          fade
          to="/projects/lectures"
          activeClassName="active"
          partiallyActive={true}
          duration={transitionTime}
        >
          <img
            draggable="false"
            className="on"
            src={nav_lectures_a}
            alt="lectures"
          />
          <img
            draggable="false"
            className="off"
            src={nav_lectures}
            alt="lectures"
          />
          <p>Lectures</p>
        </AniLink>
      </div>
    )
  } else if (path.startsWith("/about")) {
    return (
      <div className="subnav">
       <AniLink
          fade
          to="/about/backstory"
          activeClassName="active"
          partiallyActive={true}
          duration={transitionTime}
        >
          <img
            draggable="false"
            className="on"
            src={nav_backstory_a}
            alt="backstory"
          />
          <img
            draggable="false"
            className="off"
            src={nav_backstory}
            alt="backstory"
          />
          <p>backstory</p>
        </AniLink>
       <AniLink
          fade
          to="/about/profile"
          activeClassName="active"
          partiallyActive={true}
          duration={transitionTime}
        >
          <img
            draggable="false"
            className="on"
            src={nav_profile_a}
            alt="profile"
          />
          <img
            draggable="false"
            className="off"
            src={nav_profile}
            alt="profile"
          />
          <p>profile</p>
        </AniLink>
        
        
        <AniLink
          fade
          to="/about/writeups"
          activeClassName="active"
          partiallyActive={true}
          duration={transitionTime}
        >
          <img
            draggable="false"
            className="on"
            src={nav_writeups_a}
            alt="writeups"
          />
          <img
            draggable="false"
            className="off"
            src={nav_writeups}
            alt="writeups"
          />
          <p>writeups</p>
        </AniLink>
      </div>
    )
  } else {
    return null
  }
  

  
}

export default SubnavList
